import { render, staticRenderFns } from "./vsAlert.vue?vue&type=template&id=5193394e&lang=html&"
import script from "./vsAlert.vue?vue&type=script&lang=js&"
export * from "./vsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsAlert.vue"
export default component.exports